import { Box, TextField, TextFieldProps, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { uniqueId } from "lodash";
import SearchIcon from "@icons/myicons/search.svg?react";

export const SearchField = ({
  ref,
  value,
  size,
  onChange,
  placeholder,
  InputProps,
  ...rest
}: TextFieldProps & { size?: string; ref?: React.Ref<HTMLDivElement> }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isSmall = size === "small";

  return (
    <TextField
      ref={ref}
      placeholder={
        placeholder || t("singleAccountPage.protocolTable.search.placeholder")
      }
      id={`search-field-${uniqueId()}`}
      autoComplete="new-password"
      value={value}
      onChange={onChange}
      {...rest}
      sx={{
        width: "300px",
        "& .MuiInputBase-root": {
          height: isSmall ? "40px" : "44px",
        },
        [theme.breakpoints.down(750)]: { width: "100%" },
        ...rest.sx,
      }}
      slotProps={{
        input: {
          startAdornment: (
            <Box color="icon.secondary" height="24px">
              <SearchIcon width="24px" height="24px" />
            </Box>
          ),
          ...InputProps,
        },
      }}
    />
  );
};
